import { useLocation } from 'react-router-dom';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import CreatePassword from '../pages/Auth/CreatePassword';
import Onboarding from '../pages/OnBoarding/OnBoarding';

const ForgotPasswordRoutes = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  return (
    <Onboarding>
      {token ? <CreatePassword type='reset' /> : <ForgotPassword />}
    </Onboarding>
  );
};

export default ForgotPasswordRoutes;
